var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolidity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "371 243 545 833",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solidity",
    transform: "translate(402.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    opacity: 0.45,
    enableBackground: "new    ",
    d: "M371.772,135.308L241.068,367.61H-20.158l130.614-232.302 H371.772"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    opacity: 0.6,
    enableBackground: "new    ",
    d: "M241.068,367.61h261.318L371.772,135.308H110.456 L241.068,367.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    opacity: 0.8,
    enableBackground: "new    ",
    d: "M110.456,599.822L241.068,367.61L110.456,135.308 L-20.158,367.61L110.456,599.822z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    opacity: 0.45,
    enableBackground: "new    ",
    d: "M111.721,948.275l130.704-232.303h261.318L373.038,948.275 H111.721"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    opacity: 0.6,
    enableBackground: "new    ",
    d: "M242.424,715.973H-18.893l130.613,232.303h261.317 L242.424,715.973z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    opacity: 0.8,
    enableBackground: "new    ",
    d: "M373.038,483.761L242.424,715.973l130.614,232.303 l130.704-232.303L373.038,483.761z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidity);
export default __webpack_public_path__ + "static/media/solidity.71c0a49887092b6c1c0d4e7f1cf34d4d.svg";
export { ForwardRef as ReactComponent };